import { RiCompass4Line, Stack } from 'component-library';
import { useTranslation } from 'react-i18next';

import { PlotReportFactElement } from '@/api/rest/resources/types/fact';
import { NCCardSectionHeader } from '@/components/NCCard/NCCard';
import { NCFactCapsule } from '@/components/NCFactCapsule/NCFactCapsule';
import { getDisplayNumber } from '@/hooks/useDisplayNumber';

import { InvasiveSpeciesTable } from './components/InvasiveSpeciesTable';

export const InvasiveSpeciesStatsTile = ({
  speciesIdFact,
  registeredSpeciesIdFact,
}: {
  speciesIdFact: PlotReportFactElement[];
  registeredSpeciesIdFact: PlotReportFactElement[];
}) => {
  const { t } = useTranslation();

  const registeredSpeciesCount =
    registeredSpeciesIdFact.filter((f) => typeof f.value === 'number' && f.value > 0)?.length ?? 0;
  const registeredSpeciesPct =
    registeredSpeciesCount > 0 ? (registeredSpeciesCount / registeredSpeciesIdFact.length) * 100 : 0;
  const registerSpeciesPctDisplay = `${getDisplayNumber(registeredSpeciesPct)} ${t('global.ui.unit.%')}`;

  const observedSpeciesCount = speciesIdFact.filter((f) => typeof f.value === 'number' && f.value > 0)?.length ?? 0;
  const observedSpeciesPct = observedSpeciesCount > 0 ? (observedSpeciesCount / speciesIdFact.length) * 100 : 0;
  const observedSpeciesPctDisplay = `${getDisplayNumber(observedSpeciesPct)} ${t('global.ui.unit.%')}`;

  return (
    <Stack spacing={8} className='px-6 py-8' data-testid='invasive-species-stats-tile'>
      <NCCardSectionHeader title={t('shared.ncaDetail.details.invasiveSpecies.labels.speciesRegister')} />
      <Stack spacing={8} direction='row'>
        {speciesIdFact.length > 0 && (
          <NCFactCapsule
            capsuleIconProps={{
              icon: <RiCompass4Line />,
              variant: 'default',
            }}
            label={t('shared.ncaDetail.details.invasiveSpecies.labels.observedSpecies')}
          >
            <span className='typography-h3 text-text-primary'>
              {t('shared.ncaDetail.details.invasiveSpecies.stats.speciesRegister', {
                count: observedSpeciesCount,
                total: speciesIdFact.length,
                pct: observedSpeciesPctDisplay,
              })}
            </span>
          </NCFactCapsule>
        )}
        {registeredSpeciesIdFact.length > 0 && (
          <NCFactCapsule
            capsuleIconProps={{
              icon: <RiCompass4Line />,
              variant: 'default',
            }}
            label={t('shared.ncaDetail.details.invasiveSpecies.stats.speciesDetected')}
          >
            <span className='typography-h3 text-text-primary'>
              {t('shared.ncaDetail.details.invasiveSpecies.stats.speciesDetectedDisplay', {
                count: registeredSpeciesCount,
                total: registeredSpeciesIdFact.length,
                pct: registerSpeciesPctDisplay,
              })}
            </span>
          </NCFactCapsule>
        )}
      </Stack>
      <Stack className='gap-4 rounded-2xl px-4 overflow-x-hidden'>
        <InvasiveSpeciesTable observedSpecies={speciesIdFact} registeredSpecies={registeredSpeciesIdFact} />
      </Stack>
    </Stack>
  );
};
